import React from 'react';
import './expansion.scss';

export default class ExpansionEx extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            expanded: false,
            prevExpanded: false,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.expanded != prevState.prevExpanded) {
            if (nextProps.expanded) {
                return { expanded: true, prevExpanded: nextProps.expanded };
            } else {
                return { expanded: false, prevExpanded: nextProps.expanded };
            }
        }
        return null;
    }

    render() {
        const { expaned, ...other } = this.props;
        return <Expansion {...other} expanded={this.state.expanded}/>
    }
}

export class Expansion extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    static defaultProps = {
        expanded: false,
    }

    open() {
        if (!this.root || !this.box) return;
        this.root.style.height = this.box.getBoundingClientRect().height + 'px';
    }

    close() {
        if (!this.root || !this.box) return;
        var height = this.box.getBoundingClientRect().height;
        this.root.className = '';
        this.root.style.height = height + 'px';
        this.root.getBoundingClientRect();//force browser re-layout
        this.root.style.height = 0;
    }

    componentDidMount() {
        if (this.props.expanded) {
            this.root.style.height = 'auto';
        } else {
            this.root.style.height = 0;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.expanded != prevProps.expanded) {
            if (this.props.expanded) {
                this.open();
            } else {
                this.close();
            }
        }
    }

    render() {
        const className = 'pubhub-listpanel-expansion' + (this.props.className ? (' ' + this.props.className) : '') + (this.props.expanded ? ' expansion-open' : ' expansion-close');

        return (
            <div ref={dom => { this.root = dom }} className={className}>
                <div ref={dom => { this.box = dom }} className='pubhub-listpanel-expansion-box'>
                    {this.props.children}
                </div>
            </div>
        );
    }
}